<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ $t('message.booking') }}</h3>
            </div>
        </div>
        <div class="layout__main">
            <div class="layout__main-form">
                <div class="card">
                    <div class="card__content">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <div class="form-group">
                                        <input-field id="booking" name="booking" v-model="form.booking">
                                            {{ $t('message.booking') }}
                                        </input-field>
                                        <button v-show="!bookingConsultado" class="btn-success" type="button" @click="consultarBooking"><i class="fa fa-check"></i></button>
                                        <button v-show="bookingConsultado" class="btn-danger" type="button" @click="quitarBooking"><i class="fa fa-ban"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field readonly vMoney :format="int" id="cantidad_total" placeholder="###" name="cantidad_total" v-model="cantidad_total">
                                        {{ $t('message.cantidadTotal') }}
                                    </input-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field readonly vMoney :format="int" id="despachados" placeholder="###" name="despachados" v-model="despachados">
                                        {{ $t('message.totalDespachados') }}
                                    </input-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field :readonly="!bookingConsultado" vMoney :format="int" id="nuevos" placeholder="###" name="nuevos" v-model="form.despachados">
                                        {{ $t('message.despachadosIN') }}
                                    </input-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="layout__main-buttons">
                <div class="card">
                    <div class="card__content">
                        <button :disabled="!bookingConsultado" @click="guardar" class="btn-success" type="button"><i class="fa fa-save"></i><span>{{ $t('message.guardar') }}</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data : function () {
        return {
            form : {
                booking : '',
                despachados : 0
            },
            url : url,
            despachados : 0,
            cantidad_total : 0,
            bookingConsultado : false,
            int : int
        };
    },
    methods : {
        consultarBooking : function () {
            let that = this;
            axios.get(this.url + '/booking/' + this.form.booking).then(function (response) {
                that.bookingConsultado = true;
                that.cantidad_total = response.data.booking_count;
                that.despachados = response.data.despachado_count;
                that.form.despachados = response.data.kim_booking !== null?response.data.kim_booking.kim_booking_in:0;
            });
        },
        quitarBooking : function () {
            this.bookingConsultado = false;
            this.despachados = 0;
            this.cantidad_total = 0;
            this.form.booking = '';
            this.form.despachados = 0;
        },
        guardar : function () {
            if (this.form.despachados !== '' && this.form.despachados !== undefined && this.form.despachados !== null) {
                let that = this;
                axios.post(this.url + '/booking', this.form).then(function (response) {
                    swal(that.$t('message.bookingActualizado'), 'Aviso', 'success');
                }).catch(function (error) {
                    if (error !== null && error !== undefined) {
                        let response = error.response;
                        if (response !== null && response !== undefined) {
                            if (response.status === 422) 
                            {
                                swal(that.$t('message.errorBooking'), 
                                    that.$t('message.aviso'), 'warning');
                                    return;
                            }
                        }
                        swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                    }
                });
            }
            else 
                swal(this.$t('message.despachosRequeridos'), this.$t('message.aviso'), 'warning');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/Booking.vue